import { ChevronRight, Receipt } from 'lucide-preact'
import { text } from '#contract'
import { useView } from '../../../app/use-view.ts'
import { useT } from '../../../i18n/index.ts'
import { itemsText } from './basket-bar.tsx'
import styles from './checkout.module.css'
import tracker from './tracker.module.css'
import { orderStatus } from './order-tracker.tsx'
import { useShop } from './shop-context.ts'

/** The shop's orders under way, newest first: each opens its tracker. */
export function OrdersList() {
  const t = useT()
  const { vendor, money, nav } = useShop()
  const all = useView((view) => view.shops.orders)
  const orders = all.filter((order) => order.vendor === vendor.id).reverse()
  if (orders.length === 0) {
    return (
      <div class={styles.empty}>
        <Receipt aria-hidden="true" />
        <p>{t(text('shop.noOrders'))}</p>
      </div>
    )
  }
  return (
    <div class={styles.sheet}>
      <div class={styles.box}>
        {orders.map((order) => {
          const items = order.lines.reduce((sum, line) => sum + line.count, 0)
          return (
            <button
              key={order.id}
              type="button"
              class={tracker.orderRow}
              onClick={() => {
                nav.push({ kind: 'order', order: order.id })
              }}
            >
              <span class={tracker.orderInfo}>
                <span class={styles.value}>{t(text('shop.order', { id: order.id }))}</span>
                <span class={styles.label}>
                  {t(
                    text('shop.orderLine', {
                      items: itemsText(items),
                      money: money(order.totalCents),
                    }),
                  )}
                </span>
              </span>
              <span class={tracker.orderStatus} data-there={order.state === 'atDoor' || undefined}>
                {t(orderStatus(order))}
              </span>
              <ChevronRight aria-hidden="true" />
            </button>
          )
        })}
      </div>
    </div>
  )
}
